export default {"src":"/_next/static/media/illustration-tailor.a877878d.svg","height":152,"width":152};